import clsx from 'clsx'
import React, { forwardRef, MutableRefObject, useEffect, useRef, useState } from 'react'

import { CMSBar } from '@Components/CMS/Bar/CMSBar'
import { NATIVE_MODAL_OPEN_CLASS } from '@Components/Modal/NativeModal/NativeModal'
import { MainHeader } from '@Domains/Navigation/Features/MainHeader/MainHeader'
import { useGroupVisibilityRef } from '@Globals/ScrollPosition'

import styles from './header.module.scss'

const HEADER_POPUP_LIMIT = 50
export const Header = forwardRef<HTMLDivElement, {}>((_, ref) => {
  const lastScrollTop = useRef(0)
  const scrollUpRefDiff = useRef(0)
  const innerRef = useRef<HTMLDivElement | null>(null)
  const headerRef = useRef<HTMLDivElement>(null)
  const [float, setFloat] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return () => {}
    }

    function scrollAction() {
      if (document.getElementsByClassName(NATIVE_MODAL_OPEN_CLASS).length > 0) {
        return
      }

      if (window.innerWidth >= 1024) {
        return
      }

      const st = document.documentElement.scrollTop
      // SCROLLING DOWN
      if (st > lastScrollTop.current) {
        setFloat(false)
        document.documentElement.style.setProperty('--header-height', '-1px')
        scrollUpRefDiff.current = 0
        // SCROLLING UP
      } else if (st < lastScrollTop.current) {
        scrollUpRefDiff.current = Math.min(HEADER_POPUP_LIMIT, scrollUpRefDiff.current + Math.abs(st - lastScrollTop.current))
        if (scrollUpRefDiff.current >= HEADER_POPUP_LIMIT) {
          setFloat(st !== 0)
          document.documentElement.style.setProperty('--header-height', `${st !== 0 ? (innerRef.current?.clientHeight || 0) - 1 : -1}px`)
        }
      }
      lastScrollTop.current = st <= 0 ? 0 : st
    }

    window.addEventListener('scroll', scrollAction, { passive: true })
    scrollAction()

    return () => {
      window.removeEventListener('scroll', scrollAction)
    }
  }, [])

  return (
    <>
      <div className={clsx(styles.shadow, float && styles.floating)} style={innerRef.current?.clientHeight ? { height: innerRef.current?.clientHeight } : {}} />
      <div className={clsx(styles.header, float && styles.floating)} ref={ref as MutableRefObject<HTMLDivElement>}>
        <div ref={innerRef}>
          <header
            className={clsx({
              header: true,
            })}
            ref={headerRef}
            style={{
              display: 'flex',
              flexDirection: 'column',
              zIndex: '2',
              position: 'relative',
            }}
          >
            <MainHeader />
            <CMSBar placement="top" />
          </header>
        </div>
      </div>
    </>
  )
})

export const HeaderWithGroupVisibility = () => {
  const ref = useGroupVisibilityRef('header')

  return <Header ref={ref} />
}
